import {Form} from "react-bootstrap";
import {formatPhoneNumber} from "../../../Services/ApiService";

function ClientContact(props) {
    const contact = props.contacts[props.index];

    return (
        <div className={'clientContact'}>
            <div id='contact block'>
                <Form.Control id={'name'}
                              onChange={e => {contact.name.set(e.target.value)}}
                              value={contact.get().name}
                              placeholder={'Name'}
                />
                <Form.Control id={`phone`}
                              onChange={e => {contact.phone.set(e.target.value)}}
                              value={formatPhoneNumber(contact.get().phone)}
                              placeholder={'Phone'}
                />
                <Form.Control id={`email`}
                              onChange={e => {contact.email.set(e.target.value)}}
                              value={contact.get().email}
                              placeholder={'Email'}
                />
            </div>
        </div>
    )
}

export default ClientContact;